<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <!-- <el-form-item label="项目名称:">
                <el-input size="small" v-model="dataForm.projectName" placeholder="项目名称" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <el-form-item label="询价单编码:">
                <el-input size="small" v-model="dataForm.rfqCode" placeholder="询价单编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <!-- 询价开始 询价中 询价结束 -->
            <el-form-item label="询价单状态:">
                <el-select v-model="dataForm.rfqStatus" placeholder="请选择" clearable @change="getDataList" size="small">
                    <el-option v-for="item in rfqStatusList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sourcing:rfq:newRfq')" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建询价单
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    导入询价单
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bRFQ style="width: 100%;" :header-cell-style="{background:'#f5f5f5'}" :default-expand-all="false" border :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="rfqCode" header-align="center" align="left" label="询价单编码" width="160">
                </el-table-column>
                <el-table-column prop="rfqName" header-align="left" align="left" label="询价单名称">
                </el-table-column>
                <el-table-column prop="taskCode" header-align="center" align="left" label="任务编码" width="160">
                </el-table-column>
                <!-- <el-table-column prop="taskName" header-align="center" align="left" label="任务名称">
                </el-table-column> -->
                <!-- ????? -->
                <!-- <el-table-column prop="rfqType" header-align="left" align="left" label="询价单类型">
            </el-table-column> -->
                <el-table-column prop="times" header-align="center" align="right" label="轮次" width="80">
                </el-table-column>
                <el-table-column prop="delayTimes" header-align="center" align="right" label="延期次数" width="80">
                </el-table-column>
                <el-table-column prop="quotationStopTime" header-align="center" align="right" label="报价截止日期" :formatter="dateFormat" width="170">
                </el-table-column>
                <el-table-column prop="priceBit" header-align="center" align="right" label="价格位数" width="100">
                </el-table-column>
                <el-table-column prop="rfqStatus" header-align="center" align="center" label="状态" width="80">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.rfqStatus)">
                            {{rfqStatusFormat(scope.row.rfqStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="quotationStatus" header-align="center" align="center" label="报价状态" width="80">
                <template slot-scope="scope">
                    <span :class="getStatusClass(scope.row.quotationStatus)">
                        {{quotationStatusFormat(scope.row.quotationStatus)}}
                    </span>
                </template>
            </el-table-column> -->
                <!-- <el-table-column prop="createTime" header-align="center" align="left" label="创建时间" :formatter="dateFormat"> -->
                <el-table-column prop="rfqCreateTime" header-align="center" align="right" label="创建时间" :formatter="dateFormat" width="170">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="190" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger" :disabled="scope.row.rfqStatus !== RFQ_STATUS.BEGIN">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" @close="addOrUpdateVisible = false"></add-or-update>
        <!-- <add-or-update-q v-if="addOrUpdateQVisible" ref="addOrUpdateQ" @refreshDataList="getDataList"></add-or-update-q> -->
        <!-- <RfqDialog ref="rfqDialog" @refreshDataList="getDataList" /> -->
    </div>
</div>
</template>

<script>
import {
    fetchRFQList,
    deleteRFQ
} from '@/controller/rfq'
import AddOrUpdate from './rfq-add-or-update'
// import AddOrUpdateQ from './rfq-quotation-add-or-update'
// import RfqDialog from './rfq-dialog'
import moment from 'moment'
import {
    RFQ_STATUS,
    RFQ_STATUS_VALUE,
    QUOTATION_STATUS_VALUE,
    getRFQ_STATUS_VALUE,
    getLabelByValue
} from '@/utils/const'
// require('@/mock/mockRFQ');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                rfqCode: '',
                projectName: '',
                rfqStatus: ''
            },
            RFQ_STATUS: RFQ_STATUS,
            RFQ_STATUS_VALUE: RFQ_STATUS_VALUE,
            rfqStatusList: RFQ_STATUS_VALUE,
            getLabelByValue: getLabelByValue,
            getRFQ_STATUS_VALUE: getRFQ_STATUS_VALUE,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,

            //----分割线
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 215
            }
        }
    },
    components: {
        AddOrUpdate,
        // AddOrUpdateQ
    },
    activated() {
        this.getDataList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        rfqStatusFormat: function (value) {
            value = String(value)
            if (!value) {
                return ''
            }
            return getLabelByValue(RFQ_STATUS_VALUE, value)
        },
        quotationStatusFormat: function (value) {
            value = String(value)
            if (!value) {
                return ''
            }
            return getLabelByValue(QUOTATION_STATUS_VALUE, value)
        },
        // // 新增或编辑子节点
        // addChildHandle(id, parentId, parentName, parentNodePath) {

        //     console.log(id, parentId, parentName, parentNodePath)
        //     this.addOrUpdateVisible = true
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
        //     })
        // },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchRFQList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                totalPage: this.totalPage,
                ...this.dataForm
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            // if (row && row.rfqStatus === RFQ_STATUS.RFQEND) {
            //     this.addOrUpdateQVisible = true
            //     this.$nextTick(() => {
            //         // this.$refs.addOrUpdateQ.init(row, row ? row.id : 0, true, 0, null, null, null)
            //     })
            // } else {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : 0, true, 0, null, null, null)
            })
            // }
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            console.log(row)
            // if (row && row.rfqStatus === RFQ_STATUS.RFQEND) {
            //     this.addOrUpdateQVisible = true
            //     this.$nextTick(() => {
            //         // this.$refs.addOrUpdateQ.init(row, row ? row.id : 0, false, 0, null, null, null)
            //     })
            // } else {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : 0, false, 0, null, null, null)
            })

            // this.$refs.RfqDialog.open()
            // }
        },
        // 删除
        deleteHandle(id) {
            console.log(id)
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteRFQ({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-primary"
                    break;
                case '6b':
                    className = "text-danger"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        }
    }
}
</script>
